import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { HelperService } from 'src/app/modules/core';
import { ShareSimulationService } from '../../services/share-simulation.service';
import { ConfirmCloseDialogComponent } from '../confirm-close-dialog';

export interface Email {
    email: string;
}

@Component({
    selector: 'share-simulation-dialog-app',
    templateUrl: 'share-simulation-dialog.component.html',
    styleUrls: ['./share-simulation-dialog.component.scss'],
})
export class ShareSimulationDialogComponent {
    addOnBlur = true;
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    emails: Email[] = [];
    download: boolean = false;
    shareViaEmail: boolean = true;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ShareSimulationDialogComponent>,
        private helperService: HelperService,
        private shareServiver: ShareSimulationService,
    ) {}

    btnShareNow() {
        if (!this.download && !this.shareViaEmail) {
        } else {

            this.dialogRef.close();

            this.shareServiver.share(+this.router.url.split('=')[1]).subscribe(async res => {
                let html = res.parameters.contentHtml;
                const parser = new DOMParser();
                const document123 = parser.parseFromString(html, 'text/html');
                const div = document.createElement('div');
                div.setAttribute('id', 'pdf-image');
                div.appendChild(document123.body);
                document.body.prepend(div);

                html2canvas(document.getElementById('pdf-image')?.firstChild as any).then(async canvas => {
                    let fileWidth = 208;
                    let fileHeight = (canvas.height * fileWidth) / canvas.width;
                    const FILEURI = canvas.toDataURL('image/png');
                    let PDF = new jsPDF('p', 'mm', 'a4');
                    let position = 0;
                    PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight, undefined, 'FAST');
                    if (this.download) {
                        PDF.save(`${this.router.url.split('=')[1]}.pdf`);
                    }
                    if (this.shareViaEmail) {
                        var file = PDF.output('blob');
                        let email: string[] = this.emails.map(d => d.email);
                        const formData = new FormData();
                        formData.append('file', new File([file], 'pdf.pdf'));
                        this.shareServiver.sendMail(formData, email.toString()).subscribe(res => {
                            console.log(res);
                        });
                    }

                    document.body.removeChild(div);
                });
            });
        }
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our fruit
        if (value && !this.emails?.find(e => e.email == value) && this.helperService.isValidEmail(value)) {
            this.emails.push({ email: value });
        }

        // Clear the input value
        event.chipInput!.clear();
    }

    remove(email: Email): void {
        const index = this.emails.indexOf(email);

        if (index >= 0) {
            this.emails.splice(index, 1);
        }
    }

    blobToBase64(blob: any) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    onCloseModal() {
        const confirmCloseDialog = this.dialog.open(ConfirmCloseDialogComponent, {
            width: '400px',
            height: '250px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });

        confirmCloseDialog.afterClosed().subscribe(data => {
            if (data == 'OK') {
                this.dialogRef.close();
            }
        });
    }
}
